/**
 * Provides variations from a Guidewire service
 *
 * getExperimentVariant {Promise}
 *      It fulfils with a selected option for the user.
 *      E.g. 0 or 1. In case of an error -1 is returned
 *      The value is persisted in cookies
 */

export default ['JsonRPCService', '$cookies', 'gwAbExperimentxCenter', '$q', function (JsonRPCService, $cookies, abExperimentxCenter, $q) {
    return {
        /**
         * @param {String} [experimentId]
         * @param {Object} [params]
         * @returns {Promise}
         */
        getExperimentValue: function getExperimentValue() {
            var experimentId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'guidewireExperiment';
            var params = arguments[1];

            // check experiment ID in cookies
            if ($cookies.get(experimentId)) {
                return $q.resolve($cookies.get(experimentId));
            }
            // get experiment variant
            return JsonRPCService.send(abExperimentxCenter, 'segmentation/abexperiment', 'getExperimentValue', [experimentId, params]).then(function (data) {
                $cookies.put(experimentId, data.experimentResponse); // put experiment variant in cookies
                return data.experimentResponse;
            }, function () {
                return -1;
            });
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/segmentation/abexperiment/providers/DemoGuidewireExperiment.js
// module id = 1061
// module chunks = 0